import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import '../../../CSS/private/PageContent_SideBar.css';
import { BottomNavigationAction, ListItem, ListItemButton, ListItemIcon, ListItemText, useTheme } from "@mui/material";


/**
 * @param {*} props - selected     = boolean saying whether the current tab is selected or not
 *                  - isNarrow     = determines whether the side bar item is in narrow display or not
 *                  - accentColour = the colour to set the background to if selected
 *                  - setTab       = the function for changing the currently selected tab
 *                  - consoleName  = the name of the console
 */
function AppDrawerItem(props) {

  const narrow = props.narrow;
  const selected = props.selected;
  const theme = useTheme();

  return (
    <ListItem key={props.redirect} disablePadding>
      <ListItemButton 
        onClick={() => {
          if(!selected) {
            props.handleClick(props.redirect);
          }
        }}
        sx={{ 
          bgcolor: selected? theme.palette.primary.main : "00000000",
          height: 36,
          "&:hover": {
            bgcolor: selected? theme.palette.primary.light : "000", 
          },
        }}
      >
        <ListItemIcon sx={{color: '#eeeeee', minWidth: '35px'}}>
          {props.icon}
        </ListItemIcon>
        <ListItemText primary={props.title} />
      </ListItemButton>
    </ListItem>
  )
}

export default AppDrawerItem;